export default __webpack_public_path__ + "static/media/Gaze-Estimation.0308d3dc.jpg";